import axios from "axios";
import CryptoJS from "crypto-js";
import { crypto_secret_key } from "../config";
import { fileUploadTypes, MAX_FILE_SIZE_IN_BYTES } from "../constants";
import _ from "lodash";

export const decryptToken = (encryptedValue) => {
  try {
    const decrypted = CryptoJS.AES.decrypt(encryptedValue, crypto_secret_key);
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    console.log(e);
  }
};

export const formatErrorResponse = (response) => {
  console.log(response);
  const errorMessage = response.message;

  if (errorMessage) {
    return _.isArray(errorMessage) ? errorMessage[0] : errorMessage;
  }

  return response.error;
};

export const formatErrorMessage = (error) => {
  if (axios.isAxiosError(error) && error.response) {
    // 413 -> Entity too large error. Let's show a generic message
    if (error.response.status === 413) return "An unexpected error occurred!";

    return formatErrorResponse(error.response.data);
  }

  if (error.message.includes("fails to match the required pattern")) {
    return "Password must be at least 8 characters long, contain an uppercase letter, a number, and a special character.";
  }

  return error.message;
};

export const isAuthenticated = () => {
  const token = localStorage.getItem("notap_user");
  if (token) {
    return true;
  } else {
    return false;
  }
};

export const transformFirstLetter = (stringValue) => {
  return (
    stringValue.toLowerCase().charAt(0).toUpperCase() + stringValue.slice(1)
  );
};

export const getExtension = (url) => {
  if (!url || url === "N/A") return "empty";

  const parts = url.split(".");
  return parts[parts.length - 1].toLowerCase();
};

export const getFileFromUrl = async (url) => {
  if (!url) return null;

  const result = await fetch(url);
  if (!result.ok) return null;

  const extension = getExtension(url);

  const blob = await result.blob();
  const file = new File([blob], "Attachment." + extension, {
    type: fileUploadTypes.includes(blob.type) ? blob.type : extension,
  });

  return file;
};

export const getFilename = (url) => {
  if (url && url != "" && url != "N/A") {
    let urlArray = url.split("\\");

    let urlArrayLength = urlArray.length;

    let lastItemIndex = urlArrayLength - 1;

    let extension = urlArray[lastItemIndex];

    return extension.toLowerCase();
  } else {
    let extension = "empty";

    return extension;
  }
};

export const getCurrencySymbol = (currencyList, currencyValue) => {
  let singleObj = currencyList.find(
    (singleItem) => singleItem.name == currencyValue,
  );
  return singleObj?.symbol;
};

export const debounce = (fn, ms) => {
  let timer;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn.apply(this, arguments);
    }, ms);
  };
};

export const validateFileSize = (file) => {
  return file.size <= MAX_FILE_SIZE_IN_BYTES;
};

export function truncateMiddle(text, maxLength) {
  if (text.length <= maxLength) {
    return text; // Return the original text if it's shorter than or equal to maxLength
  } else {
    const ellipsisLength = 3; // Length of "..."
    const portionLength = Math.floor((maxLength - ellipsisLength) / 2);

    const startPortion = text.substring(0, portionLength);
    const endPortion = text.substring(text.length - portionLength);

    return `${startPortion}....${endPortion}`;
  }
}

export const formatNumber = (originalValue) => {
  let formattedAmount;
  if (originalValue) {
    formattedAmount = Number(originalValue).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } else if (originalValue == 0) {
    return 0.0;
  } else {
    formattedAmount = "";
  }
  return formattedAmount;
};
